import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import "jspdf-autotable";
import { FaArrowLeft } from "react-icons/fa";
import { useSelector } from "react-redux";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";

const ComplianceChecklist = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [complianceNo, setComplianceNo] = useState("");
  const [complianceName, setComplianceName] = useState("");
  const [complianceList, setComplianceList] = useState([]);

  const filteredData = complianceList.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return ["OM_COMPLIANCE_NO", "OM_COMPLIANCE_NAME"].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  useEffect(() => {
    initialData();
  }, []);

  const initialData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1063`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setComplianceNo(response?.data[0]?.NEW_COMPLIANCE_NO);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching New Compliance No:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1065`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setisloading(false);
        setComplianceList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Compliance details:", error);
      });
  };

  // Saving
  async function SaveGateIn() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1064`,
        {
          OM_COMPLIANCE_NO: Number(complianceNo),
          OM_COMPLIANCE_NAME: complianceName,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        }
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Compliance Saved successfully`);
        console.log(`Compliance Saved successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving Compliance`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Compliance`, error);
    }
  }

  const handleRowClick = (value, index) => {
    setComplianceNo(value.OM_COMPLIANCE_NO);
    setComplianceName(value.OM_COMPLIANCE_NAME);
  };

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen">
      <AllPagesNavbar />
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          Compliance Checklist
        </h1>
        {/* <FaArrowLeft
          className="cursor-pointer hover:text-blue-300 transition-all"
          size={30}
          onClick={() => {
            window.history.back();
          }}
        /> */}
      </div>

      <div className="flex justify-center mt-6">
        <div className="bg-white border border-gray-300 shadow-md rounded-lg p-6 w-[95%] lg:w-[900px]">
          {/* Save Button */}
          <div className="flex justify-end mb-4 gap-2">
            <button
              className="flex items-center justify-center bg-[#002d62] hover:bg-[#004080] text-white font-semibold rounded-md px-4 py-2 transition-all duration-200 border border-black"
              onClick={async () => {
                window.location.reload();
              }}
            >
              New
            </button>

            <button
              className="flex items-center justify-center bg-[#002d62] hover:bg-[#004080] text-white font-semibold rounded-md px-4 py-2 transition-all duration-200 border border-black"
              onClick={async () => {
                if (!complianceName) {
                  alert("Kindly Supply Compliance Name");
                  return;
                } else {
                  await SaveGateIn();
                  window.location.reload();
                }
              }}
            >
              Save
            </button>
          </div>

          {/* Compliance Form */}
          <div className="flex flex-col lg:flex-row items-center gap-4">
            {/* Compliance No */}
            <div className="flex flex-col lg:flex-row lg:items-center gap-2 w-full lg:w-auto">
              <label className="text-red-600 font-medium min-w-max mt-0">
                Compliance No:
              </label>
              <input
                className="w-full lg:w-20 h-10 border border-gray-400 rounded-md px-3 focus:outline-none focus:border-blue-500 text-right"
                type="text"
                value={complianceNo}
                readOnly
              />
            </div>

            {/* Compliance Name */}
            <div className="flex flex-col lg:flex-row lg:first:items-center gap-2 w-full lg:w-auto">
              <label className="text-red-600 font-medium min-w-max mt-0">
                Compliance Name:
              </label>
              <input
                className="w-full lg:w-96 h-10 border border-gray-400 rounded-md px-3 focus:outline-none focus:border-blue-500"
                type="text"
                value={complianceName}
                onChange={(e) => setComplianceName(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="select_product_type" style={{ marginTop: "5px" }}>
        <div>
          <p>Search</p>
        </div>
        <div>
          <input
            type="text"
            className="w-64 h-8 border border-black rounded-md"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
        </div>
      </div>

      <div className="visible h-[500px] p-1 z-0 overflow-auto mt-2">
        <table className="w-full border border-gray-300 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-left border border-gray-300">
                SNO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                COMPLIANCE NO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                COMPLIANCE NAME
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((value, index) => (
              <tr
                key={index}
                className="hover:bg-gray-100 cursor-pointer text-[13px]"
                onClick={() => handleRowClick(value, index)}
              >
                <td className="py-2 px-4 text-right border border-gray-300">
                  {index + 1}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.OM_COMPLIANCE_NO || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.OM_COMPLIANCE_NAME || "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ComplianceChecklist;
